import { CurrencyField } from "./CurrencyField";
import SortableEntryWrapper from "./SortableEntryWrapper";

interface MonthlyPaymentEntryProps {
  id: string;
  index: number;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  onRemove: () => void;
  canRemove: boolean;
  autoFocus?: boolean;
}

export default function MonthlyPaymentEntry({
  id,
  index,
  value,
  onChange,
  onRemove,
  canRemove,
  autoFocus,
}: MonthlyPaymentEntryProps) {
  return (
    <SortableEntryWrapper id={id} onRemove={onRemove} canRemove={canRemove}>
      <CurrencyField
        label={`Monthly Payment ${index + 1}`}
        value={value ?? 0}
        onChange={(val) => onChange(val === 0 ? undefined : val)}
        fullWidth
        margin="none"
        required
        autoFocus={autoFocus}
        greaterThanZero
      />
    </SortableEntryWrapper>
  );
}
